import * as React from 'react';
import { INLINES, BLOCKS, Document } from '@contentful/rich-text-types';
import { Options, documentToReactComponents } from '@contentful/rich-text-react-renderer';
import Heading from 'components/text/Heading';
import Link from 'next/link';

const isWebLink = (url: string) => /web(-test)?(-staging)?(-dev)?\.poinz\.ch/.test(url);

type HeadingIndex = 1 | 2 | 3 | 4 | 5 | 6;

export const renderContent = (content: Array<{ value: string }>) => {
  return content.map((child, i) => {
    const { value } = child || {};
    return <React.Fragment key={`${value}-${i}`}>{value}</React.Fragment>;
  });
};

export const getHeading = (node, number: HeadingIndex, className?: string) => {
  const variant = `h${number}`;
  return (
    <Heading className={className} variant={variant as any}>
      {renderContent(node.content)}
    </Heading>
  );
};

const getOptions = (options: Options = {}) => {
  return {
    ...options,
    renderNode: {
      [BLOCKS.HEADING_1]: node => getHeading(node, 1),
      [BLOCKS.HEADING_2]: node => getHeading(node, 2),
      [BLOCKS.HEADING_3]: node => getHeading(node, 3),
      [BLOCKS.HEADING_4]: node => getHeading(node, 4),
      [BLOCKS.HEADING_5]: node => getHeading(node, 5),
      [BLOCKS.HEADING_6]: node => getHeading(node, 6),
      [INLINES.HYPERLINK]: node => {
        if (isWebLink(node.data.uri)) {
          const url = new URL(node.data.uri);
          const query = url?.searchParams ? Object.fromEntries(url.searchParams) : {};
          return (
            <Link
              href={{ pathname: url.pathname, query }}
              className="underline"
              scroll={false}
              shallow
            >
              {renderContent(node.content)}
            </Link>
          );
        }
        return (
          <Link
            href={node.data.uri}
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            {renderContent(node.content)}
          </Link>
        );
      },
      ...(options.renderNode || {})
    }
  };
};

const renderRichText = (document: Document, options?: Options) =>
  documentToReactComponents(document, getOptions(options));

export default renderRichText;
